import { FunctionComponent, useCallback } from 'react';

import { COLOUR_INDEX } from '../App/constants';
import {
  DESKTOP_MENU_ITEMS,
  DesktopMenuItem,
} from '../DesktopHeader/constants';

export const getVisitedMenuItems = (): DesktopMenuItem[] => {
  const stored = localStorage.getItem('__ksp_visited__');

  if (!stored) return DESKTOP_MENU_ITEMS;

  const parsedStored = JSON.parse(stored) as DesktopMenuItem[];
  const combined = DESKTOP_MENU_ITEMS.map((item: DesktopMenuItem) => {
    const key = item.name;
    const match = parsedStored.filter(
      (item: DesktopMenuItem) => item.name === key,
    );
    if (match.length === 0) return item;
    const { to: matchTo } = match[0];
    const { to: defaultTo } = item;
    const containsDefault = matchTo.includes(defaultTo);
    if (!containsDefault) return item;
    return match[0];
  });

  return combined;
};

export interface PresetFilterOption {
  value: string;
  text: string;
}

export interface PresetFilterProps {
  menuItem: string;
  currentPath: string;
  options: PresetFilterOption[];
}

export const PresetFilter: FunctionComponent<PresetFilterProps> = function ({
  menuItem: _menuItem,
  currentPath,
  options,
}) {
  const className =
    COLOUR_INDEX[
      options.findIndex((opt) => {
        return opt.value == currentPath;
      })
    ];
  const onChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
    const to = e.target.value;
    const menuItems = (
      JSON.parse(
        localStorage.getItem('__ksp_visited__') ||
          JSON.stringify(DESKTOP_MENU_ITEMS),
      ) as DesktopMenuItem[]
    ).map((menuItem) => {
      if (menuItem.name.toLowerCase() == _menuItem) {
        menuItem.to = e.target.value;
      }
      return menuItem;
    });
    localStorage.setItem('__ksp_visited__', JSON.stringify(menuItems));
    window.location.href = to;
  }, []);

  return (
    <select className={className} value={currentPath} onChange={onChange}>
      {options.map((opt) => {
        return <option value={opt.value}>{opt.text}</option>;
      })}
    </select>
  );
};

export default PresetFilter;
